import axios from "axios";
import Upload, { IUploadProps } from "../upload";

const imageExtensions = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/svg+xml",
  "image/tiff",
  "image/x-icon",
  "image/vnd.microsoft.icon",
  "image/vnd.wap.wbmp",
  "image/heic",
  "image/heif",
  "image/jxr",
  "image/avif",
  "image/apng",
  "image/x-png",
];

const UPLOAD_FILE_URL =
  "https://viagsapi.azurewebsites.net/api/uploadfile/upload-file";
const UPLOAD_IMG_URL =
  "https://viagsapi.azurewebsites.net/api/uploadfile/upload-file-img";

interface Props extends IUploadProps {}

const getFormDataAndAction = (file: File) => {
  const formData = new FormData();
  let action = "";
  if (file instanceof File && imageExtensions.includes(file.type)) {
    formData.append("file", file);
    action = UPLOAD_IMG_URL;
  } else {
    formData.append("files", file);
    action = UPLOAD_FILE_URL;
  }

  return { action, formData };
};

const funcFallback = () => {};

export const ViagsUpload = ({ children, ...restProps }: Props) => {
  return (
    <Upload
      multiple
      maxSizePerFile={4194304}
      action={(file) =>
        new Promise((rs) => rs(getFormDataAndAction(file).action))
      }
      customRequest={(options) => {
        const {
          file,
          onSuccess = funcFallback,
          onError = funcFallback,
        } = options;
        const { formData } = getFormDataAndAction(file as File);
        axios
          .post(options.action, formData)
          .then((res) => onSuccess(res.data))
          .catch((err: Error) => onError(err));
      }}
      {...restProps}
    >
      {children}
    </Upload>
  );
};
